import React, { Component, useState, createRef } from "react";
import AuthBanner from "../icons/authBanner.svg";
import "../index.scss";

export default function EmptyCampaign({ data }) {
  return (
    <div className="empty-campaign-container">
      <img src={AuthBanner} />
      <h2>দুঃখিত!</h2>
      <h3> কোনো ক্যাম্পেইন খুঁজে পাওয়া যাচ্ছে না।</h3>
      {false && data && data.message && <p>{data.message}</p>}
    </div>
  );
}
